import { matterPaths } from '@/routing/paths'

export type LrrViewerMetadata = {
  s3_path: string
}

export type LrrViewerContext = {
  matterId?: string | null
  /**
   * The citation this view came from. Carried as a query param so links created before it
   * existed keep resolving; without it the viewer simply shows no drift badge, which is the
   * correct answer for a document opened outside any citation.
   */
  referenceId?: string | null
}

/**
 * Builds the URL for the standalone LRR reference viewer.
 *
 * @param metadata - Reference metadata containing s3_path
 * @param context - Optional context; when matterId is present uses matter-first path
 * @returns Standalone viewer URL, or null if s3_path is missing
 */
export function buildLrrStandaloneViewerURL(metadata: LrrViewerMetadata, context?: LrrViewerContext): string | null {
  if (!metadata.s3_path) return null

  const matterId = typeof context?.matterId === 'string' && context.matterId.trim().length > 0 ? context.matterId.trim() : null

  const path = matterPaths.referenceViewer.lrr(matterId, encodeURIComponent(metadata.s3_path))
  const referenceId = typeof context?.referenceId === 'string' && context.referenceId.trim().length > 0 ? context.referenceId.trim() : null

  return referenceId ? `${path}?referenceId=${encodeURIComponent(referenceId)}` : path
}
